module.exports = __webpack_public_path__ + "images/questions/qa_like_c6c8ce5e7794bb9bf60d02106474da1e.png";